/**
 * Quién puede ver los defectos de un catálogo.
 *
 * "Defectos" son los renglones que entraron al catálogo y no sirven para poner un
 * precio: los que no dicen en qué se miden y los que vienen sin precio
 * (`resourcesSinUnidad` / `resourcesSinPrecio`, contados al subir — migración 088).
 *
 * LA REGLA, en un solo lugar:
 *
 *  - Catálogo PROPIO de la empresa (`tenant_upload`): lo ve su dueño. Es su archivo,
 *    lo puede corregir y volver a subir; enterarse es justamente lo que le sirve.
 *  - Catálogo OFICIAL (`ecostos` y las bases de referencia por país): lo ve **solo
 *    Ecosoft**, que es quien lo mantiene. Anunciarle al cliente los defectos de
 *    nuestra propia base no le sirve de nada —no los puede arreglar— y le resta
 *    confianza en el resto de los precios.
 *
 * Vive en `shared` porque la aplican los dos lados y tienen que coincidir: el API
 * decide si manda los números y la pantalla decide si dibuja la leyenda. Si cada
 * uno tuviera su copia, alcanzaría con mirar la red para ver lo que la pantalla
 * esconde.
 */

/** Clase de catálogo (mismo union que `Catalog['kind']`). */
export type CatalogoKind = 'ecostos' | 'tenant_upload' | 'referencia';

/**
 * True si el catálogo lo publica y mantiene Ecosoft (ECOSTOS + bases de referencia
 * por país). False para el catálogo privado de una empresa.
 */
export function catalogoEsOficial(kind: CatalogoKind): boolean {
  return kind === 'ecostos' || kind === 'referencia';
}

/**
 * True si a este espectador se le pueden mostrar (y mandar) los conteos de
 * renglones defectuosos de este catálogo.
 */
export function puedeVerDefectosDelCatalogo(
  kind: CatalogoKind,
  esStaffDeEcosoft: boolean,
): boolean {
  return catalogoEsOficial(kind) ? esStaffDeEcosoft : true;
}
